import { createTheme } from "@material-ui/core";
import { APP_CONFIG } from "./config";

export const getTheme = () => createTheme(APP_CONFIG().theme);

export const getCssVariables = () => APP_CONFIG().cssVariables;
